import React, {useEffect, useState, useContext} from 'react'
import {Grid, InputLabel, FormHelperText} from '@material-ui/core'
import _ from 'lodash'
import Select from 'react-select'
import {getReservedForFieldValues} from '../../../../state/reservation/reserved-for-field-values/actions'
import useReservedForFieldValuesReducer from '../../../../state/reservation/reserved-for-field-values/reducer'
import '../../../ReservationBookings/StepActionFields/StepActionField.scss'
import {ReservationContext} from '../../../../context/Reservation'

export default function WMemoField({fieldId, fieldType, data}) {
  const [search, setSearch] = useState('')
  const [optionList, setOptionList] = useState([])
  const [list, reservedForFieldValuesDispatch] = useReservedForFieldValuesReducer()
  const newoptionList = []
  const {reservation, update} = useContext(ReservationContext)

  const getOptionList = userList => {
    if (userList) {
      if (userList && !userList.isLoading && userList.data) {
        const newOptionList = userList.data.map(fv => ({
          value: fv.id,
          label: fv.name,
        }))
        setOptionList(newOptionList)
      }
    }
  }

  useEffect(() => {
    getReservedForFieldValues(
      reservedForFieldValuesDispatch,
      [fieldId],
      fieldType,
      search
    ).then(res => getOptionList(res))
    // eslint-disable-next-line
  }, [fieldType, reservedForFieldValuesDispatch, search, fieldId])

  const onChange = (e, fieldId) => {
    const updatedFields = reservation.additional_fields.map(fv => {
      if (fv.type === 'EntityListField' && fv.id === fieldId) {
        fv.value = e?.label
      }

      return fv
    })

    update('additional_fields', updatedFields)
  }

  return (
    <Grid item xs={6} className="select-search-container">
      <Select
        classNamePrefix="select"
        className="select-search search-border"
        isSearchable={true}
        isLoading={list.isLoading}
        labelId="demo-mutiple-name-label"
        id="demo-simple-select"
        placeholder={data.name}
        isClearable={true}
        options={optionList}
        onChange={e => {
          onChange(e, fieldId, fieldType)
        }}
        onInputChange={e => setSearch(e)}
      />
      <FormHelperText className="helper-text-margin">
        {!data.is_required ? 'optional' : ''}
      </FormHelperText>
    </Grid>
  )
}
